/* Longhorn Clean Sheet — theme.js (ES5-safe, no dependencies) */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---- Mobile drawer ---- */
  var drawer = $('#drawer'), burger = $('[data-drawer-open]');
  function openDrawer() { if (!drawer) return; drawer.hidden = false; document.body.classList.add('drawer-open'); if (burger) burger.setAttribute('aria-expanded', 'true'); var f = $('a,button', drawer); if (f) f.focus(); }
  function closeDrawer() { if (!drawer) return; drawer.hidden = true; document.body.classList.remove('drawer-open'); if (burger) { burger.setAttribute('aria-expanded', 'false'); burger.focus(); } }
  if (burger) burger.addEventListener('click', openDrawer);
  if (drawer) { $$('[data-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', closeDrawer); }); document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeDrawer(); }); }

  /* ---- ZIP checker (tiers from theme settings) ---- */
  var zipForm = $('[data-zip-form]');
  if (zipForm) {
    var tiers = {};
    try { tiers = JSON.parse($('[data-zip-tiers]').textContent); } catch (e) {}
    var out = $('[data-zip-out]');
    zipForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var z = ($('#zip').value || '').trim(); out.className = 'out';
      if (!/^\d{5}$/.test(z)) { out.textContent = 'Enter a 5-digit ZIP.'; return; }
      if ((tiers.free || []).indexOf(z) !== -1) { out.className = 'out ok'; out.textContent = 'Free delivery to ' + z + '. Same-day available.'; }
      else if ((tiers.t2 || []).indexOf(z) !== -1) { out.textContent = '$' + tiers.fee2 + ' delivery to ' + z + '. Still same-day.'; }
      else if ((tiers.t3 || []).indexOf(z) !== -1) { out.textContent = '$' + tiers.fee3 + ' delivery to ' + z + '.'; }
      else { out.textContent = '$' + tiers.fee4 + ' delivery to ' + z + '. Text us to confirm the route.'; }
    });
  }

  /* ---- Review quote dots ---- */
  var dots = $$('[data-dots] button');
  dots.forEach(function (b) {
    b.addEventListener('click', function () {
      dots.forEach(function (x) { x.classList.remove('on'); }); b.classList.add('on');
      $('[data-quote]').textContent = b.getAttribute('data-quote-text');
      $('[data-quote-by]').textContent = b.getAttribute('data-quote-who');
    });
  });

  /* ---- Catalog v2: tiles -> sub-row -> grid, all client-side (longhorn-catalog-tiles.html) ---- */
  var cat = $('[data-cat]');
  if (cat) {
    var grid = $('[data-grid]', cat), cards = $$('.set', grid);
    var tiles = $$('[data-tiles] .tile'), rt = $('[data-rt]', cat), emptyEl = $('[data-empty]', cat);
    var subBrand = $('[data-sub-brand]', cat), subSingle = $('[data-sub-single]', cat);
    var brandChips = subBrand ? $$('.fc', subBrand) : [], singleChips = subSingle ? $$('.fc', subSingle) : [];
    var T = 'all', K = 'all', S = 'all', fadeT = null;
    function num(el, a) { return parseFloat(el.getAttribute(a)) || 0; }
    function apply() {
      grid.classList.add('fade'); clearTimeout(fadeT); fadeT = setTimeout(function () { grid.classList.remove('fade'); }, 160);
      var n = 0;
      cards.forEach(function (k) {
        var kind = k.getAttribute('data-kind'), show;
        if (T === 'all') show = kind === 'set' && (K === 'all' || (K === '__stack' ? k.getAttribute('data-stack') === '1' : k.getAttribute('data-brand') === K));
        else if (T === 'single') show = (kind === 'washer' || kind === 'dryer') && (S === 'all' || kind === S);
        else show = k.getAttribute('data-deal') === '1';
        k.classList.toggle('is-hidden', !show); if (show) n++;
      });
      if (subBrand) { subBrand.hidden = T !== 'all'; brandChips.forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-k') === K); }); }
      if (T !== 'all') K = 'all';
      if (subSingle) { subSingle.hidden = T !== 'single'; singleChips.forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-k') === S); }); }
      if (T !== 'single') S = 'all';
      var name = T === 'all' ? (K === 'all' ? 'All sets' : K === '__stack' ? 'Stackable sets' : K + ' sets') : T === 'single' ? (S === 'washer' ? 'Single washers' : S === 'dryer' ? 'Single dryers' : 'Singles') : 'Marked down';
      if (rt) rt.textContent = name + ' · ' + n;
      tiles.forEach(function (x) { var on = x.getAttribute('data-t') === T; x.classList.toggle('on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      if (emptyEl) emptyEl.hidden = n !== 0;
      var h = T === 'all' ? (K === 'all' ? '' : K === '__stack' ? '#stackable' : '#brand-' + encodeURIComponent(K)) : T === 'single' ? (S === 'all' ? '#single' : '#single-' + S) : '#deal';
      try { history.replaceState(null, '', h || location.pathname + location.search); } catch (e) {}
    }
    brandChips.forEach(function (b) { b.addEventListener('click', function () { K = b.getAttribute('data-k'); apply(); }); });
    singleChips.forEach(function (b) { b.addEventListener('click', function () { S = b.getAttribute('data-k'); apply(); }); });
    tiles.forEach(function (t) {
      t.addEventListener('click', function () {
        T = t.getAttribute('data-t'); apply();
        if (!rt) return;
        var y = rt.getBoundingClientRect().top + window.pageYOffset - 86;
        if (window.pageYOffset > y - 40) { try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, y); } }
      });
    });
    var sort = $('[data-sort]', cat);
    function doSort() {
      var key = sort ? sort.value : 'price';
      var sorted = cards.slice().sort(function (a, b) {
        var pa = num(a, 'data-price'), pb = num(b, 'data-price');
        if (key === 'new') return (num(b, 'data-new') - num(a, 'data-new')) || (pa - pb);
        if (key === 'cap') return (num(b, 'data-cap') - num(a, 'data-cap')) || (pa - pb);
        if (key === 'cond') return (num(a, 'data-cond') - num(b, 'data-cond')) || (pa - pb);
        return pa - pb;
      });
      sorted.forEach(function (k) { grid.appendChild(k); });
    }
    if (sort) { sort.addEventListener('change', doSort); if (sort.value !== 'price') doSort(); }
    /* right-edge fade on the tile row (phones) */
    var tw = $('[data-tw]'), tl = $('[data-tiles]');
    if (tw && tl) {
      var chk = function () { tw.classList.toggle('end', tl.scrollLeft + tl.clientWidth >= tl.scrollWidth - 4); };
      tl.addEventListener('scroll', chk, { passive: true }); chk();
    }
    var initial = decodeURIComponent((location.hash || '').slice(1));
    if (initial === 'deal') T = 'deal';
    else if (initial === 'stackable') K = '__stack';
    else if (initial === 'single' || initial === 'single-washer' || initial === 'single-dryer') { T = 'single'; S = initial.slice(7) || 'all'; }
    else if (initial.indexOf('brand-') === 0) { K = initial.slice(6); }
    apply();
  }

  /* ---- Reviews: live Google/Facebook numbers + rotating 5-star quote (snippets/trust-block.liquid) ----
     Server-rendered fallback values stay on screen; live values only replace them when the endpoint
     answers ok with non-zero numbers. Quote area reserves the tallest quote's height so rotation never
     shifts the layout. */
  var trustCfgEl = $('[data-trust-config]');
  if (trustCfgEl) {
    var tcfg = {}; try { tcfg = JSON.parse(trustCfgEl.textContent); } catch (e) {}
    var tGoogle = { rating: parseFloat(tcfg.google && tcfg.google.rating) || 0, count: parseInt(tcfg.google && tcfg.google.count, 10) || 0 };
    var tFacebook = { rating: parseFloat(tcfg.facebook && tcfg.facebook.rating) || 0, count: parseInt(tcfg.facebook && tcfg.facebook.count, 10) || 0 };
    var tBlock = $('[data-trust-block]'), tRot = null, tResizeBound = false, tList = [];
    function tSet(key, v) { $$('[data-trust="' + key + '"]').forEach(function (el) { el.textContent = v; }); }
    function tPaint() {
      if (tGoogle.rating > 0 && tGoogle.count > 0) { tSet('google-rating', tGoogle.rating.toFixed(1)); tSet('google-count', String(tGoogle.count)); }
      if (tFacebook.rating > 0 && tFacebook.count > 0) { tSet('facebook-rating', tFacebook.rating.toFixed(1)); tSet('facebook-count', String(tFacebook.count)); }
      var tot = (tGoogle.count > 0 ? tGoogle.count : 0) + (tFacebook.count > 0 ? tFacebook.count : 0);
      if (tot > 0) {
        var avg = ((tGoogle.rating * (tGoogle.count > 0 ? tGoogle.count : 0)) + (tFacebook.rating * (tFacebook.count > 0 ? tFacebook.count : 0))) / tot;
        tSet('combined-rating', (Math.round(avg * 10) / 10).toFixed(1)); tSet('combined-count', String(tot));
      }
    }
    function tReserve() {
      var p = tBlock && $('[data-trust-quote]', tBlock); if (!p || !tList.length) return;
      var cur = p.textContent, max = 0; p.style.minHeight = '0px';
      tList.forEach(function (q) { p.textContent = '\u201c' + q.quote + '\u201d'; if (p.offsetHeight > max) max = p.offsetHeight; });
      p.textContent = cur; p.style.minHeight = max + 'px';
    }
    function tStart(list) {
      if (!tBlock) return;
      list = (list || []).filter(function (q) { return q && q.quote; }).slice(0, 3);
      if (!list.length) return;
      tList = list;
      var p = $('[data-trust-quote]', tBlock), who = $('[data-trust-who]', tBlock), dw = $('[data-trust-dots]', tBlock);
      if (!p || !who || !dw) return;
      dw.innerHTML = ''; list.forEach(function (_, k) { var b = document.createElement('b'); if (k === 0) b.className = 'on'; dw.appendChild(b); });
      var dots = $$('b', dw), i = 0;
      function show(k) { p.textContent = '\u201c' + list[k].quote + '\u201d'; who.textContent = list[k].who + ' \u00b7 Google'; dots.forEach(function (d, j) { d.classList.toggle('on', j === k); }); }
      show(0); tReserve();
      if (tRot) clearInterval(tRot);
      if (list.length > 1) tRot = setInterval(function () { if (document.hidden) return; i = (i + 1) % list.length; show(i); }, 5000);
      if (!tResizeBound) { tResizeBound = true; var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(tReserve, 120); }); if (document.fonts && document.fonts.ready) document.fonts.ready.then(tReserve); }
    }
    if (tBlock) { var fb = []; try { fb = JSON.parse($('[data-trust-fallback]', tBlock).textContent); } catch (e) {} tStart(fb); }
    if (tcfg.endpoint && window.fetch) {
      fetch(tcfg.endpoint, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (d) {
        if (!d || !d.ok || !d.google) return;
        if (d.google.rating > 0 && d.google.count > 0) tGoogle = { rating: d.google.rating, count: d.google.count };
        if (d.facebook && d.facebook.rating > 0 && d.facebook.count > 0) tFacebook = { rating: d.facebook.rating, count: d.facebook.count };
        tPaint();
        if (tBlock && d.google.reviews && d.google.reviews.length) tStart(d.google.reviews);
      }).catch(function () {});
    }
  }

  /* ---- Repair page: symptom picker (longhorn-repair.html) ---- */
  var sym = $('[data-sym]');
  if (sym) {
    var symData = {}; try { symData = JSON.parse($('[data-sym-data]').textContent); } catch (e) {}
    var ans = $('[data-ans]'), syBtns = $$('.sy', sym);
    function pickSym(b, scroll) {
      syBtns.forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-expanded', 'false'); });
      b.classList.add('on'); b.setAttribute('aria-expanded', 'true');
      var a = symData[b.getAttribute('data-k')]; if (!a || !ans) return;
      $('[data-ans-t]', ans).textContent = a.t; $('[data-ans-h]', ans).textContent = a.h; $('[data-ans-p]', ans).textContent = a.p;
      $('[data-ans-vt]', ans).textContent = a.v; $('[data-ans-v]', ans).className = 'verdict' + (a.g ? '' : ' n');
      ans.classList.add('show');
      if (scroll) { try { ans.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {} }
    }
    syBtns.forEach(function (b) { b.addEventListener('click', function () { pickSym(b, true); }); });
    /* theme editor: selecting a symptom block opens its answer */
    document.addEventListener('shopify:block:select', function (e) { var b = e.target; if (b && b.classList && b.classList.contains('sy') && sym.contains(b)) pickSym(b, false); });
  }

  /* ---- Product gallery thumbs ---- */
  var gallery = $('[data-gallery]');
  if (gallery) {
    var track = $('[data-gallery-track]', gallery), thumbs = $$('[data-thumb]', gallery), slides = $$('[data-slide]', gallery);
    function selectThumb(i) { thumbs.forEach(function (t, k) { t.setAttribute('aria-selected', String(k === i)); }); }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { var i = parseInt(t.getAttribute('data-thumb'), 10); if (slides[i] && track) track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); selectThumb(i); }); });
    if (track && slides.length > 1) { var tk = false; track.addEventListener('scroll', function () { if (tk) return; tk = true; setTimeout(function () { tk = false; selectThumb(Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)))); }, 80); }, { passive: true }); }
  }

  /* ---- Cart: terms gate + persist attribute ---- */
  var cartForm = $('[data-cart-form]');
  if (cartForm) {
    var terms = $('[data-terms]', cartForm), termsErr = $('[data-terms-error]', cartForm);
    if (terms) {
      terms.addEventListener('change', function () {
        if (termsErr) termsErr.hidden = terms.checked;
        try { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Terms and Policies Accepted': terms.checked ? 'Yes' : '' } }) }); } catch (e) {}
      });
      cartForm.addEventListener('submit', function (e) { if (!terms.checked) { e.preventDefault(); if (termsErr) termsErr.hidden = false; terms.focus(); } });
    }
  }

  /* ---- Ad landing page: two-tap chooser (longhorn-ad-landing.html) ----
     Budget picks the tier; 5+ people bumps Budget up to Best value, 1-2 people bumps Premium
     down to Best value. A tier whose collection was empty is not on the page, so the pick falls
     back to the nearest card that is. Outlines the chosen card, renames its label via CSS
     (.tier.pick .lab:after) and scrolls it into view. */
  var chz = $('[data-chooser]');
  if (chz) {
    var st = {};
    function tierEl(id) { return $('#' + id); }
    function nearest(id) {
      var order = id === 't1' ? ['t1', 't2', 't3'] : id === 't3' ? ['t3', 't2', 't1'] : ['t2', 't1', 't3'];
      for (var i = 0; i < order.length; i++) { var el = tierEl(order[i]); if (el) return el; }
      return null;
    }
    function choose() {
      if (!st.hh || !st.bd) return;
      var pick = st.bd === 1 ? 't1' : st.bd === 2 ? 't2' : 't3';
      if (st.hh === 3 && pick === 't1') pick = 't2';
      if (st.hh === 1 && pick === 't3') pick = 't2';
      var el = nearest(pick);
      if (!el) return;
      $$('.tier').forEach(function (t) { t.classList.remove('pick', 'mid'); });
      el.classList.add('pick');
      try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { el.scrollIntoView(); }
    }
    $$('.opts', chz).forEach(function (g) {
      $$('.o', g).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('.o', g).forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-pressed', 'false'); });
          b.classList.add('on'); b.setAttribute('aria-pressed', 'true');
          st[g.getAttribute('data-q')] = parseInt(b.getAttribute('data-v'), 10);
          choose();
        });
        b.setAttribute('aria-pressed', 'false');
      });
    });
  }

  /* ---- Just sold toast (sections/just-sold.liquid) ----
     Sales come from the backend (/api/recent-sales — real orders) when jc.endpoint is set,
     otherwise from the section's blocks. First show after `initial`, on screen for `show`, then a
     random gap in [min,max]; shuffled. × hides it for the session. Nothing shows if the live
     endpoint fails — never a stand-in list. */
  var js = $('[data-jsold]'), jsCfgEl = $('[data-jsold-config]');
  if (js && jsCfgEl) {
    var jc = {}; try { jc = JSON.parse(jsCfgEl.textContent); } catch (e) {}
    var jsDone = false; try { jsDone = sessionStorage.getItem('lh_jsold_off') === '1'; } catch (e) {}
    if (!jsDone) {
      var sales = [], jq = [], ji = 0, jTimer = null, jStarted = false;
      var jm = $('[data-jsold-main]', js), jt = $('[data-jsold-time]', js), jx = $('[data-jsold-close]', js);
      function jShuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var k = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[k]; a[k] = t; } return a; }
      function jWhen(s) {
        var m = s.at ? Math.max(1, Math.round((Date.now() - Date.parse(s.at)) / 60000)) : (parseInt(s.m, 10) || 0);
        if (m < 60) return m + ' minute' + (m === 1 ? '' : 's') + ' ago';
        if (m < 120) return 'an hour ago';
        if (m < 1440) return Math.floor(m / 60) + ' hours ago';
        var d = Math.floor(m / 1440); return d === 1 ? 'yesterday' : d + ' days ago';
      }
      function jWho(s) { var mode = jc.name || 'first'; if (mode === 'anon') return 'Someone'; if (mode === 'initial' && s.l) return s.n + ' ' + s.l + '.'; return s.n; }
      function jNext() { if (ji >= jq.length) { jq = jShuffle(sales); ji = 0; } return jq[ji++]; }
      function jHide(cb) { js.classList.remove('is-on'); jTimer = setTimeout(function () { js.hidden = true; if (cb) cb(); }, 320); }
      function jShow() {
        if (jsDone || !sales.length) return;
        var s = jNext();
        jm.textContent = jWho(s) + ' in ' + s.c + ' ' + (jc.verb || 'bought a') + ' ' + s.p; jt.textContent = jWhen(s);
        js.hidden = false; requestAnimationFrame(function () { js.classList.add('is-on'); });
        jTimer = setTimeout(function () { jHide(function () { var gap = (jc.min || 25) + Math.random() * ((jc.max || 45) - (jc.min || 25)); jTimer = setTimeout(jShow, gap * 1000); }); }, (jc.show || 5) * 1000);
      }
      function jStart(list) {
        sales = (list || []).filter(function (s) { return s && s.n && s.c && s.p; });
        if (jStarted || sales.length < 2) return;
        jStarted = true; jTimer = setTimeout(jShow, (jc.initial || 8) * 1000);
      }
      jx.addEventListener('click', function () { jsDone = true; clearTimeout(jTimer); try { sessionStorage.setItem('lh_jsold_off', '1'); } catch (e) {} jHide(); });
      if (jc.endpoint && window.fetch) {
        fetch(jc.endpoint, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (d) { if (d && d.ok) jStart(d.sales); }).catch(function () {});
      } else {
        jStart(jc.sales);
      }
    }
  }
})();
